import React, { useEffect, useState } from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import {faXmark} from "@fortawesome/free-solid-svg-icons/faXmark";
import BackgroundImg from "../../assets/images/wa-chat-bg.png"
import {faFaceSmile} from "@fortawesome/free-regular-svg-icons";
import "../../assets/css/website.css";
import requestApi from "../../../../services/requestApi.service";
import whatsAppIcon from "../../../../assets/utils/images/whatsapp.png";
import {getSiteURL, parseJSON} from "../../../../Common/Appcommon";

const WebsiteWidget = (props) => {
    const [isWhatsappWidget, setShowWhatsappWidget] = useState(false);
    const [widgetData, setWidgetData] = useState({});
    const [inputValue, setInputText] = useState("");
    const siteURL = getSiteURL();
    let widgetId = props.match === undefined || props.match.params.id === undefined ? '' : props.match.params.id;
    useEffect(() => {
        (async () => {
            if(props.isPreviewWidget){
                setWidgetData(props.widgetData);
                setShowWhatsappWidget(true);
            } else {
                await loadWhatsappWidgetContent();
            }
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);
    const loadWhatsappWidgetContent = async() => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_WEBSITE_WIDGET_DATA",
            "id" : widgetId,
            "isOtherApiReq" : true,
        }
        let response = await requestApi.processCustomProcessorRequest("GET_WEBSITE_WIDGET_DATA",params);
        if(response.issuccess) {
            if(response.data.length > 0){
                let data = response.data[0]['data'];
              
                data = parseJSON(data);
                setWidgetData(data);
            }

        }
    }
    const toggleWhatsAppWidgetPanel = (e) => {
        if (window && window.parent) {
            setShowWhatsappWidget(!isWhatsappWidget);
            let fn = "minimizeWindow";
            if(!isWhatsappWidget){
                fn = "restoreWindow";
            }
            window.parent.postMessage({src: 'cratio.whatsapp.widget', fn: fn, args: []}, '*');
        }
    }
    const onInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setInputText(value);
    }
    const openWhatsAppChatApi = (e) => {
        let toNumber = widgetData.wa_number !== undefined ? widgetData.wa_number : "";
        let msgText = widgetData.triggerMsg !== undefined ? widgetData.triggerMsg : "";
        let apiUrl = "https://api.whatsapp.com/send?phone="+toNumber+"&text="+msgText;
        window.open(apiUrl, "_blank");
    }
    return (
        <>
            <div>
                {
                    !isWhatsappWidget && <div className={'bcon-container-body '}>
                        <div className={'bcon-container'}>
                            <button onClick={(e) => {toggleWhatsAppWidgetPanel(e)}}>
                        <span>
                            <FontAwesomeIcon icon={faWhatsapp}/>
                        </span>
                            </button>
                            <div className="notification-badge">1</div>
                        </div>
                    </div>
                }
                {isWhatsappWidget && <div className={`widget-container ${props.isPreviewWidget ? 'widget-preview-container' : ''}`}>
                    <div className={'main-container'}>
                        <div className={`conversation-container ${props.isPreviewWidget ? 'conversation-preview' : ''}`}>
                            <div className={'conversation-header'}>
                                <img className="icon" src={widgetData.logoUrl !== "" && widgetData.logoUrl !== undefined ? widgetData.logoUrl : whatsAppIcon} alt="logo"/>
                                <p>
                                    <strong className="title overlope-dot-250px">{widgetData.brandName !== undefined ? widgetData.brandName : "Name"}</strong>
                                    <span className="online-status overlope-dot-250px">{widgetData.availableTag !== undefined ? widgetData.availableTag : "Online"}</span>
                                </p>
                                <button className={`close-button ${props.isPreviewWidget ? 'hide' : ''}`} aria-label="Close the Chat Widget" onClick={(e) => {toggleWhatsAppWidgetPanel(e)}}>
                                    <i className="flex">
                                        <FontAwesomeIcon icon={faXmark}/>
                                    </i>
                                </button>
                            </div>
                            <div className={'messages-container'} style={{
                                backgroundImage: `url(${BackgroundImg})`,
                            }}>
                                {!props.isLinkGenerator && <div>
                                    <div className={`messages `}>
                                        <div className={'message-bubble tri-right left-top'}>
                                            <div className={'message-text'}>
                                                <p className="model-message-bg">{widgetData.welcomeTxt !== undefined ? widgetData.welcomeTxt : "Welcome Text"}</p>
                                            </div>
                                        </div>

                                    </div>
                                    <div className={`whatsappChatWidgetButtonPreview position-bottom ${props.isPreviewWidget ? '' : 'waChatWidgetPosition'} ${props.isbuttonNeeded !== undefined && !props.isbuttonNeeded ? 'hide' : ''}`}>
                                        <a className="whatsappChatWidgetStartChat cursor-pointer" role="button" onClick={(e) => {openWhatsAppChatApi(e)}} target="_blank" title="WhatsApp" >
                                            <span className="whatsappChatWidgetButtonTextPreview" ><FontAwesomeIcon icon={faWhatsapp}/> Start Chat</span></a>
                                    </div>
                                </div>
                                }
                                {props.isLinkGenerator &&
                                    <div>
                                        <div className="flex flex-col gap-y-2.5">
                                            <div className="flex justify-end w-full pr-2.5">
                                                <div className={'message-text'}>
                                                <p className="bg-green-light p-2 rounded-xl max-w-xs ">
                                                    {widgetData.welcomeTxt !== undefined ? widgetData.welcomeTxt : "Welcome Text"}
                                                </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                    <div className={'flex items-center justify-center hide'}>
                                        <div className={'flex flex-nowrap mt-2'}>
                                            <span className="text-xs text-gray-600">Powered by </span>
                                            <a className="powered-by-a text-xs text-blue-500 font-semibold flex flex-nowrap"
                                               target="_blank"
                                               href={siteURL}
                                               rel="noreferrer">cratiocrm</a>
                                        </div>
                                    </div>

                            </div>
                        </div>
                    </div>
                </div>
                }
                {props.isLinkGenerator &&
                    <div>
                        <div className={'flex items-center px-2'}>
                            <div className={'flex relative bg-white bgr-9 mx-2'}>
                                <span className={'absolute inset-y-0 left-0 flex items-center wpl-2'}>
                                    <span
                                        className={'wp-1 focus:outline-none focus:shadow-outline text-gray-400'}>
                                            <FontAwesomeIcon icon={faFaceSmile}/>
                                    </span>
                                </span>
                                    <input 
                                        disabled={true} 
                                        name={"inputTxt"} 
                                        onChange={(e) => {
                                            onInputChange(e)
                                        }} 
                                        autoComplete="off" 
                                        placeholder="Send a message"
                                        className="rounded-full pl-10 pr-5 shadow flex-grow chatbox-whatsapp-wiget whatsapp-wiget-testbox"
                                        type="text"
                                    />
                                </div>
                                <span>
                                    <a 
                                        target={"_blank"} 
                                        style={{backgroundColor: 'rgb(7, 94, 84)'}}
                                        className={'cursor-pointer flex items-center justify-center text-white rounded-full h-10 w-10 shadow'}>
                                            <i className={'flex'}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18"
                                                    height="18">
                                                    <path fill="currentColor"
                                                        d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path>
                                                </svg>
                                            </i>
                                    </a>
                                </span>
                            </div>
                        </div>
                    }
            </div>

        </>
    )
}

export default WebsiteWidget;
